module.exports = __webpack_public_path__ + "static/img/55beffd83e36f2d9f0b75de36145e582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon1(1).jpg
// module id = +Fi/
// module chunks = 1